import { JobData } from "./types";

export const getJobTitle = (job: JobData) => {
  const { jobTitle, externalTitle } = job.jobReqLocale.results;
  return externalTitle ?? jobTitle ?? "";
};
